<template>
  <div class="book-reader-wrapper">
    <template v-if="!readerError && ownsBook && bookId && userId">
      <ColibrioCirrusReader
        :book-id="bookId"
        :user-id="userId"
        :unencrypted-file-path="currentBook?.unencryptedFilePath"
        @error="handleError"
        @loaded="handleLoaded"
      />
      <reader-loading v-if="readerLoading" />
    </template>
    <div
      v-else-if="readerError"
      class="message-container"
    >
      <h2 class="mb-4">
        {{ $t('reader.loadError') }}
      </h2>
      <div class="button-group">
        <v-btn
          color="primary"
          class="mr-2"
          @click="reloadPage"
        >
          {{ $t('reader.reloadPage') }}
        </v-btn>
        <v-btn
          outlined
          color="primary"
          @click="$router.push({ name: 'book', params: { id: bookId } })"
        >
          {{ $t('common.returnToShop') }}
        </v-btn>
      </div>
    </div>
    <div
      v-else-if="!ownsBook && !bookshelfLoading"
      class="message-container"
    >
      <h2 class="mb-4">
        {{ $t('bookInfo.notInLibrary') }}
      </h2>
      <v-btn
        color="primary"
        @click="$router.push({ name: 'book', params: { id: bookId } })"
      >
        {{ $t('common.returnToShop') }}
      </v-btn>
    </div>
    <reader-loading v-else />
  </div>
</template>

<script>
import ColibrioCirrusReader from '@/components/ColibrioCirrusReader.vue';
import ReaderLoading from '@/components/ReaderLoading.vue';
import BookshelfMixin from '@/mixins/BookshelfMixin';

export default {
  name: 'BookReader',
  metaInfo() {
    return {
      title: this.$t('routes.reader'),
    }
  },
  components: {
    ColibrioCirrusReader,
    ReaderLoading,
  },
  mixins: [BookshelfMixin],
  data() {
    return {
      readerError: false,
      readerLoading: true,
    };
  },
  computed: {
    bookId() {
      return this.$route.params.id;
    },
    userId() {
      return this.$auth?.user?.sub;
    },
    currentBook() {
      if (!this.bookId) return null;
      return this.checkInBookshelf(this.bookId);
    },
    ownsBook() {
      return !!this.currentBook;
    },
  },
  methods: {
    handleError(error) {
      this.readerError = true;
      this.readerLoading = false;
      this.$store.commit('serverError/setErrorCode', 'READER_LOAD_ERROR');
      this.$store.commit('serverError/setErrorMessage', this.$t('reader.loadError'));
    },
    handleLoaded() {
      this.readerLoading = false;
    },
    reloadPage() {
      window.location.reload();
    },
  },
};
</script>

<style scoped>
.book-reader-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.message-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
}

.button-group {
  display: flex;
  gap: 8px;
}
</style>
